var Dlrt;
(function (Dlrt) {
    class ModalBase {
        constructor(modal) {
            this.modal = modal;
        }
        get Modal() {
            return this.modal;
        }
        find(selector) {
            return this.modal.find(selector);
        }
        show() {
            this.modal.modal('show');
        }
        hide() {
            this.modal.modal('hide');
        }
        onHide(callback) {
            this.modal.on('hidden.bs.modal', callback);
        }
    }
    Dlrt.ModalBase = ModalBase;
    function LoadModalAsync(ajaxParameters, container, createModal) {
        const defaultParameters = {
            method: 'GET',
            traditional: true,
            success: () => { },
            error: () => {
                container.empty();
                container.append('<div class="error text-center">Failed to load modal window</div>');
            }
        };
        const fullParameters = $.extend({}, defaultParameters, ajaxParameters);
        $.ajax(fullParameters).done((data) => {
            container.empty();
            container.html(data);
            const modal = createModal(container.children('.modal'));
            modal.show();
        });
    }
    Dlrt.LoadModalAsync = LoadModalAsync;
})(Dlrt || (Dlrt = {}));

//# sourceMappingURL=modalBase.js.map
